import { useOutletContext } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ModelShowcase } from "@/components/home/ModelShowcase";
import { OffersSection } from "@/components/home/OffersSection";
import { Manifesto } from "@/components/home/Manifesto";
import { StatsStrip } from "@/components/home/StatsStrip";
import { GalleryPreview } from "@/components/home/GalleryPreview";
import { TestDriveCTA } from "@/components/home/TestDriveCTA";
import { LocationSection } from "@/components/home/LocationSection";

const num = (n) => String(n).padStart(2, "0");

export default function Home() {
  const { settings, vehicles, gallery, offers } = useOutletContext();
  const marquee = [...vehicles.map((v) => v.name), "Sales · Service · Spare Parts", "West Canal Road, Faisalabad", "Authorized 3S Dealership"];
  const shift = offers.length ? 1 : 0;

  return (
    <div data-testid="home-page">
      <Hero settings={settings} vehicles={vehicles} />
      <Marquee items={marquee} />
      <ModelShowcase vehicles={vehicles} offers={offers} />
      <OffersSection offers={offers} vehicles={vehicles} number="02" />
      <StatsStrip stats={settings.stats} />
      <Manifesto settings={settings} number={num(2 + shift)} />
      <GalleryPreview items={gallery} number={num(3 + shift)} />
      <TestDriveCTA vehicle={vehicles[0]} />
      <LocationSection settings={settings} number={num(4 + shift)} />
    </div>
  );
}
